import { Navigate } from "react-router-dom";
import type { ReactNode } from "react";
import { useAppSelector } from "../../hooks/redux";
import { SETUP_ROUTES } from "./routes";

interface RequireSetupStepProps {
  requiredStep: number;
  children: ReactNode;
}

/**
 * Gate setup wizard sub-routes so a user cannot deep-link past a step they
 * haven't completed. If the prior step isn't in `completedSteps`, redirect
 * to the wizard root (the dashboard).
 */
export function RequireSetupStep({
  requiredStep,
  children,
}: RequireSetupStepProps) {
  const completedSteps = useAppSelector((s) => s.setup?.completedSteps ?? []);

  if (!completedSteps.includes(requiredStep)) {
    return <Navigate to={SETUP_ROUTES.DASHBOARD} replace />;
  }

  return <>{children}</>;
}
